var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contacts container"},[_c('v-container',[_c('h1',[_vm._v("CONTACTS")]),_c('v-container',[_c('contact-table',{attrs:{"contacts":_vm.UserListJson}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }